import AdminApp from './AdminApp';
import GuestApp from './GuestApp';

export default function App() {
  return window.location.pathname.startsWith('/admin') ? <AdminApp /> : <GuestApp />;
}
